import { render, staticRenderFns } from "./BadWords.vue?vue&type=template&id=3aaf8b51&scoped=true&"
import script from "./BadWords.vue?vue&type=script&lang=js&"
export * from "./BadWords.vue?vue&type=script&lang=js&"
import style0 from "./BadWords.vue?vue&type=style&index=0&id=3aaf8b51&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaf8b51",
  null
  
)

export default component.exports